module.exports = __webpack_public_path__ + "img/moular4.6eb263c2.png";